import { ErrorBoundary } from '@rollbar/react';
import { BookingCheckout } from 'booking/components';
import { useParams } from 'react-router-dom';
import {
  CenteredSquaredContainer,
  FatalErrorWithStack,
  FullscreenImageLayout,
  Heading,
  Stack,
} from 'ui-components';
import { useDocumentTitle } from 'usehooks-ts';

export function NewBookingCheckout(): JSX.Element {
  useDocumentTitle('DRYCUT - Salons');

  const { slug } = useParams() as { slug: string };

  return (
    <FullscreenImageLayout src="/images/booking-bg.jpg">
      <Stack className="lg:mt-[20vh]">
        <Heading className="hidden lg:block">right hair. right now.</Heading>
        <CenteredSquaredContainer
          wrapperClassName="overflow-hidden"
          className="2xl:w-full lg:w-full xs:m-0 md:m-0 xl:m-10 lg:px-10 2xl:px-10 max-w-screen-2xl"
        >
          <ErrorBoundary fallbackUI={FatalErrorWithStack}>
            <BookingCheckout manual={false} storeSlug={slug} />
          </ErrorBoundary>
        </CenteredSquaredContainer>
      </Stack>
    </FullscreenImageLayout>
  );
}
